const toTwoDigits = (integer) => ('0' + integer).slice(-2)

const formatTime = (dateString) => {
	if (!dateString) return
	let dateObject = new Date(dateString)
	let hours = toTwoDigits(dateObject.getHours())
	let minutes = toTwoDigits(dateObject.getMinutes())
	return `${hours}:${minutes}`
}

const formatDate = (dateString) => {
	if (!dateString) return
	let dateObject = new Date(dateString)
	let date = toTwoDigits(dateObject.getDate())
	let month = toTwoDigits(dateObject.getMonth() + 1)
	let year = dateObject.getFullYear()
	return `${date}/${month}/${year}`
}

export { toTwoDigits, formatTime, formatDate }
